import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { useNavigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {

    const token = localStorage.getItem("token");
    const navigate = useNavigate();

    if (!token) {
        navigate("/login");
    }

    return (
        <>
            <Header />
            {children}
            <Footer />
        </>
    )
}

export default PrivateRoute